import { Sidebar as ShellSidebar, Mark4x4, type SidebarGroup } from '@edupra/shell';
import {
  LayoutDashboard,
  Building2,
  Users,
  ScrollText,
  UserCog,
  ToggleRight,
  Receipt,
  Settings,
} from 'lucide-react';

/**
 * Platform-admin sidebar.
 *
 * Three groups:
 *   - Platform     — high-frequency operator destinations
 *   - Operations   — audit + active impersonation oversight
 *   - Configuration— per-tenant settings the operator can flip
 *
 * Unlike the tenant sidebar there's no per-role visibility filter wired in
 * yet — every platform user can see every link. Permission checks happen
 * server-side via `supportProcedure` / `ownerProcedure`. We can layer in
 * client-side hide-by-role once the dedicated screens land (Agent 5/7).
 */
const groups: SidebarGroup[] = [
  {
    label: 'Platform',
    items: [
      { label: 'Overview', href: '/overview', icon: LayoutDashboard },
      { label: 'Tenants', href: '/tenants', icon: Building2 },
      { label: 'Operators', href: '/operators', icon: Users },
    ],
  },
  {
    label: 'Operations',
    items: [
      { label: 'Audit Log', href: '/audit', icon: ScrollText },
      { label: 'Impersonation Sessions', href: '/impersonation', icon: UserCog },
    ],
  },
  {
    label: 'Configuration',
    items: [
      { label: 'Feature Flags', href: '/feature-flags', icon: ToggleRight },
      { label: 'Billing', href: '/billing', icon: Receipt },
      { label: 'Settings', href: '/settings', icon: Settings },
    ],
  },
];

export function AdminSidebar() {
  return (
    <ShellSidebar
      brand={{
        mark: <Mark4x4 size={32} accent={{ row: 3, col: 3 }} />,
        title: 'edupra',
        subtitle: 'Platform Console',
      }}
      groups={groups}
      footer={
        <div className="flex items-center justify-between">
          <span className="font-mono">admin · v0.1</span>
          <span className="inline-flex items-center gap-1">
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--color-accent-400)] animate-pulse" />
            Operator
          </span>
        </div>
      }
    />
  );
}
